import styles from "../../pages/CodesList.module.css"

interface BulkDeleteModelProps {
  selectedCodes: string[];
  handleBulkDeleteModalCancel: () => void;
  handleConfirmBulkDelete: () => void;
}

const BulkDeleteModel = ({ selectedCodes, handleBulkDeleteModalCancel, handleConfirmBulkDelete }: BulkDeleteModelProps) => {
  return (
    <div className={styles.modalOverlay}>
    <div className={styles.modalContent}>
      <h3 className={styles.modalTitle}>
        האם אתה בטוח שברצונך למחוק את המספרים שנבחרו (
        {selectedCodes.length})?
      </h3>
      <div className={styles.modalActions}>
        <button
          onClick={handleBulkDeleteModalCancel}
          className={styles.cancelButton}
        >
          ביטול
        </button>
        <button
          onClick={handleConfirmBulkDelete}
          className={styles.deleteButton}
        >
          מחק
        </button>
      </div>
    </div>
  </div>  
);
};

export default BulkDeleteModel;